import { EnvironmentProviders, inject, provideEnvironmentInitializer, ProviderToken } from '@angular/core';

/**
 * Creates the given root stores at bootstrap. Their resources are keyed on the session, so the reads behind the
 * home page start as soon as the member is logged in instead of when the home components are created.
 */
export const provideHomePrefetch = (...stores: ProviderToken<unknown>[]): EnvironmentProviders =>
  provideEnvironmentInitializer(() => stores.forEach(store => inject(store)));
